import { createApi } from '@reduxjs/toolkit/query/react';
import { encodeParam } from './loginApi';
import baseQuery from './fetchBaseQuery';
import { RedirectResponse, VerifiedPasswordResetRequest } from '../types';

const api = createApi({
    reducerPath: 'passwordApi',
    baseQuery,
    endpoints: build => ({
        forgotPassword: build.mutation<void, string>({
            query: email => ({
                url: `/password/api/forgot?email=${encodeParam(email)}`,
                method: 'POST',
            }),
        }),
        resetPassword: build.mutation<
            RedirectResponse,
            VerifiedPasswordResetRequest & { next?: string }
        >({
            query: ({ username, password, verificationRequest, next }) => ({
                url: `/password/api/reset?next=${encodeParam(next)}`,
                method: 'POST',
                body: {
                    username,
                    password,
                    verificationRequest,
                },
            }),
        }),
    }),
});
export const { useForgotPasswordMutation, useResetPasswordMutation } = api;
export default api;
